import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState, } from 'react';
import { Button } from 'design-system/Button';
import { ButtonGroup } from 'design-system/ButtonGroup';
import useColors from 'hooks/useColors';
import { Avatar } from 'design-system/avatar';
import { SpaceInviteAction } from 'design-system/SpaceInviteAction';
import { useAppSelector } from 'store/hooks';
import { selectUser } from 'reducers/selectors';
import IconSend from 'design-system/icons/IconSend';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import AnimatedIconBell from 'features/pay/icons/AnimatedIconBell';
import iconSource from 'design-system/img/notifications.png';
import PaymentToastModal from 'features/pay/components/toast/PaymentToastModal';
import { isWeb } from '../../constants';
import { useManageSpaceInvite } from './hooks';
const ManageSpaceInvite = ({ route, navigation, }) => {
    const { spaceId, inviteId, status, firstName, lastName, imageUrl, spaceName, memberId, handle, } = route.params;
    const colors = useColors();
    const user = useAppSelector(selectUser);
    const onFinish = useCallback(() => {
        navigation.goBack();
    }, []);
    const { createInvite, sendReminder, cancelInvite, fetchingCreateInvite, fetchingSendReminder, fetchingCancelInvite, } = useManageSpaceInvite(spaceId, inviteId, memberId, handle, onFinish);
    const onDismiss = useCallback(() => {
        navigation.goBack();
    }, []);
    const [showToast, setShowToast] = useState(false);
    useEffect(() => {
        if (fetchingSendReminder && !showToast) {
            setShowToast(true);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [fetchingSendReminder, showToast]);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: isWeb
                ? undefined
                : () => (<NavigationCloseButton onPress={onDismiss} colorKey="primary"/>),
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary, colors.text.white, onDismiss]);
    const { title, message, secondaryButtonText, primaryButtonText } = useMemo(() => {
        if (status === 'PENDING')
            return {
                title: `${user.firstName} invited ${firstName}`,
                message: `to join "${spaceName}"`,
                secondaryButtonText: 'Cancel invitation',
                primaryButtonText: 'Send reminder',
            };
        return {
            title: `${firstName} rejected the invitation`,
            message: `to join "${spaceName}"`,
            secondaryButtonText: 'Delete',
            primaryButtonText: 'Invite again',
        };
    }, [spaceName, firstName, status, user.firstName]);
    const leftIcon = useMemo(() => status === 'PENDING' ? (<AnimatedIconBell isFetching={fetchingSendReminder} tintColor={colors.elements.white}/>) : (<IconSend color={colors.elements.white}/>), [colors.elements.white, fetchingSendReminder, status]);
    return (<>
      <PaymentToastModal isVisible={showToast} onCloseAction={() => setShowToast(false)} title="Sent a reminder to join space" message={`To ${firstName ?? ''}`} iconSource={iconSource}/>
      <SpaceInviteAction title={title} subTitle={message} icon={<Avatar name={firstName ?? ''} lastName={lastName ?? ''} size={54} color={colors.background.brandLight} borderWidth={1} fontColor={colors.text.textOnBrand} imageUrl={imageUrl}/>}>
        <ButtonGroup type="floating">
          <Button isFetching={fetchingCancelInvite} brandReversed onPress={cancelInvite} title={secondaryButtonText} disabled={fetchingCancelInvite || fetchingCreateInvite}/>
          <Button isFetching={fetchingCreateInvite} brand leftIcon={leftIcon} onPress={status === 'PENDING' ? sendReminder : createInvite} title={primaryButtonText} disabled={fetchingCancelInvite || fetchingCreateInvite}/>
        </ButtonGroup>
      </SpaceInviteAction>
    </>);
};
export default ManageSpaceInvite;
